export const AmlReviewActions = {
  Read: 'aml-review:read',
} as const;

export const AccountActions = {
  Read: 'account:read',
} as const;

export const CardActions = {
  Read: 'card:read',
} as const;

export const CardTokenActions = {
  Read: 'card-token:read',
} as const;

export const FundingSourceActions = {
  Read: 'funding-source:read',
} as const;
